import { render, staticRenderFns } from "./crowdfundingFollow.vue?vue&type=template&id=3f0b73de&scoped=true"
import script from "./crowdfundingFollow.vue?vue&type=script&lang=js"
export * from "./crowdfundingFollow.vue?vue&type=script&lang=js"
import style0 from "./crowdfundingFollow.vue?vue&type=style&index=0&id=3f0b73de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0b73de",
  null
  
)

export default component.exports